export const installationData = {
    name: 'Alpha Aviation',
    flightDetailOperatorLine:
        'Operator: Alpha Aviation s.r.o. | Hulkova 31, Prague 9, 19700 Czech Republic | ops@alpha-aviation.aero | +420 702 161 575',
};

export const camoData = {
    name: 'Alpha Aviation s.r.o.',
    approval: 'CZ.CAMO.0085',
    officialAddress: 'Na Tržišti 731\n39 470 Kamenice nad Lipou',
    vat: 'CZ28137370',
    contactAddress: 'Prague Ruzyně Airport (LKPR)\nK letišti 1040/10, 161 00 Praha 6',
    email: 'camo@alpha-aviation.aero',
    phone: '+420211150560',
    cam: 'Jana Ptáčková',
};

export const flightBriefData = {
    opsPhone: '+420 211 150 520',
    opsEmail: 'ops@alpha-aviation.aero',
    salesPhone: '+420 211 150 510',
    salesEmail: 'sales@alpha-aviation.aero',
    invoicesEmail: 'invoices@alpha-aviation.aero',
};
